import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { PaymentAgentKey } from 'api/Wallet/Types/PaymentAgentDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const clientDetailsPOAColumns: GridColumn[] = [
  {
    title: 'Name',
    // width: 440,
    // minResizableWidth: 440,
    field: PaymentAgentKey.name,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsPaymentAgents.detailsUrl as string, {
              id: props.dataItem.paymentAgent.id,
            }),
          }}
        >
          {props.dataItem.paymentAgent.name}
        </Link>
      </td>
    ),
    show: true,
    filter: 'text',
  },
  {
    title: 'Created',
    // width: 240,
    show: true,
    filter: 'text',
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
  },
]

export default clientDetailsPOAColumns
